import { render, staticRenderFns } from "./MonitoringTarget.vue?vue&type=template&id=33d78c67"
import script from "./MonitoringTarget.vue?vue&type=script&lang=ts"
export * from "./MonitoringTarget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports